import React from 'react';
import { Organization } from '../../../types/domain';
import { Button } from '../../../components/ui/Button';
import { Trash2 } from 'lucide-react';

interface OrganizationDangerTabProps {
  currentOrg: Organization | null;
  canDeleteOrg: boolean;
  onOpenDeleteModal: () => void;
}

export const OrganizationDangerTab: React.FC<OrganizationDangerTabProps> = ({
  currentOrg,
  canDeleteOrg,
  onOpenDeleteModal,
}) => {
  return (
    <div className="p-5 rounded-lg bg-rose-500/5 border border-rose-500/30 space-y-4">
      <h2 className="text-sm font-semibold text-rose-400 flex items-center gap-2">
        <Trash2 size={16} />
        <span>Delete Organization</span>
      </h2>

      <p className="text-xs text-cf-textSecondary leading-relaxed">
        Permanently delete <strong className="text-cf-textPrimary">{currentOrg?.name}</strong>, all its projects, datastore tables, submissions, storage files, and notification dispatch rules. This action cannot be undone.
      </p>

      {canDeleteOrg ? (
        <div className="pt-2">
          <Button
            type="button"
            variant="danger"
            size="xs"
            onClick={onOpenDeleteModal}
            icon={<Trash2 size={14} />}
          >
            Delete Organization
          </Button>
        </div>
      ) : (
        <p className="text-xs text-amber-500">
          Only the organization owner or a platform superadmin can permanently delete this organization.
        </p>
      )}
    </div>
  );
};
